var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"instagram\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M68.5 0.0136719H12.5C5.87258 0.0136719 0.5 5.38626 0.5 12.0137V68.0137C0.5 74.6411 5.87258 80.0137 12.5 80.0137H68.5C75.1274 80.0137 80.5 74.6411 80.5 68.0137V12.0137C80.5 5.38626 75.1274 0.0136719 68.5 0.0136719Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c_2",
    d: "M68.5 0.0136719H12.5C5.87258 0.0136719 0.5 5.38626 0.5 12.0137V68.0137C0.5 74.6411 5.87258 80.0137 12.5 80.0137H68.5C75.1274 80.0137 80.5 74.6411 80.5 68.0137V12.0137C80.5 5.38626 75.1274 0.0136719 68.5 0.0136719Z",
    fill: "url(#paint0_radial_891_5047)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c_3",
    d: "M68.5 0.0136719H12.5C5.87258 0.0136719 0.5 5.38626 0.5 12.0137V68.0137C0.5 74.6411 5.87258 80.0137 12.5 80.0137H68.5C75.1274 80.0137 80.5 74.6411 80.5 68.0137V12.0137C80.5 5.38626 75.1274 0.0136719 68.5 0.0136719Z",
    fill: "url(#paint1_linear_891_5047)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M51.9062 15.9512H29.0938C22.1039 15.9512 16.4375 21.6176 16.4375 28.6074V51.4199C16.4375 58.4098 22.1039 64.0762 29.0938 64.0762H51.9062C58.8961 64.0762 64.5625 58.4098 64.5625 51.4199V28.6074C64.5625 21.6176 58.8961 15.9512 51.9062 15.9512Z",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M40.4999 51.2637C46.7131 51.2637 51.7499 46.2269 51.7499 40.0137C51.7499 33.8005 46.7131 28.7637 40.4999 28.7637C34.2867 28.7637 29.2499 33.8005 29.2499 40.0137C29.2499 46.2269 34.2867 51.2637 40.4999 51.2637Z",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M54.7189 26.7324C55.2366 26.7324 55.6564 26.3127 55.6564 25.7949C55.6564 25.2772 55.2366 24.8574 54.7189 24.8574C54.2011 24.8574 53.7814 25.2772 53.7814 25.7949C53.7814 26.3127 54.2011 26.7324 54.7189 26.7324Z",
    stroke: "white",
    strokeWidth: 4
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_891_5047",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.5 80.0137) scale(80)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_891_5047",
    x1: 0.5,
    y1: 0.0136719,
    x2: 16.5,
    y2: 80.0137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6600FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.aca938f88d92cc73c82b87a7eb5d1d18.svg";
export { ForwardRef as ReactComponent };